import { defineMessages } from 'react-intl'
import Validation from '../lib/validation'

export const validateCreateTest = (data) => {
  const validator = new Validation(data)
  validator.isRequired('name', messages.nameRequired)
  validator.isArrayWithLength('lessons', 1, messages.lessonsMsg)
  return validator.validate()
}

export const validateUpdateTest = (data) => {
  const validator = new Validation(data)
  validator.isRequired('name', messages.nameRequired)
  validator.isArrayWithLength('lessons', 1, messages.lessonsMsg)
  return validator.validate()
}

const messages = defineMessages({
  nameRequired: {
    id: 'validations.tests.nameRequired',
    defaultMessage: 'Názov je povinný.',
  },
  lessonsMsg: {
    id: 'validations.tests.lessonsMsg',
    defaultMessage: 'Aspoň jedno cvičenie je povinné.',
  },
})



// WEBPACK FOOTER //
// ./src/common/tests/validations.js